module.exports = __webpack_public_path__ + "fonts/bhicons.f4ee58aa.ttf";